module.exports = __webpack_public_path__ + "img/cl+cl-r-dub.476e0f3f.jpg";